import baseMob from '@/router/mob/base';
import basePc from '@/router/pc/base';
import getMenuRouter from '@/router/pc/admin.js';
import adminMobileRouter from '@/router/mob/admin.js';
import CreateAppRouter from '@/router/app';
import CreateBusinessRouter from '@/router/business';

var VUE = null
var _permissionRouter = false
var isMobile = false



const CreateRouter = (Router, Store, Vue) => {
  if (Vue.prototype.$utils.isApp()) {
    return CreateAppRouter(Router, Store, Vue)
  }
  if (Vue.prototype.$utils.isBusiness()) {
    return CreateBusinessRouter(Router, Store, Vue)
  }
  // 
  VUE = Vue
  isMobile = VUE.prototype.$utils.isMobile()
  const router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({
      y: 1
    }),
    routes: [
      ...(isMobile ? baseMob : basePc),
    ]
  })
  // 权限限制
  router._initRouterByPermission = () => {
    if (_permissionRouter) return;
    var loginInfo = VUE.prototype.$utils.isLogin();
    if (loginInfo) {
      var privileges = VUE.prototype.$utils.parsePrivileges(loginInfo.privileges);
      router.addRoutes(isMobile ? adminMobileRouter : getMenuRouter(privileges, loginInfo.role));
      _permissionRouter = true
    }
  }
  router._initRouterByPermission()
  router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
      if (VUE.prototype.$utils.isLogin()) {
        next('/notFound')
      } else {
        next('/login?login=auto&redirect=' + window.location.href + '')
      }
    } else {
      next()
    }
  })
  return router
}

export default CreateRouter



// WEBPACK FOOTER //
// ./src/router/index.js